import React, { useState, useEffect, useRef } from "react";
import "react-toastify/dist/ReactToastify.css";
import _, { sum } from "lodash";
// UI components
import ButtonElement from "../../../Components/UiComponents/ButtonElement";
import { Accordion, AccordionTab } from "primereact/accordion";
import InputTextElementElement from "../../../Components/UiComponents/InputTextElement";
import { useForm, Controller } from "react-hook-form";
import ToastElement from "../../../Components/UiComponents/ToastElement";
// Services
import {
  get,
  getCustomerControlField,
  updateRef
} from "../../../Services/customerServices";
import Loader from "../../../Components/UiComponents/Loader";
import { useNavigate } from "react-router-dom";
import PlaylistVideos from "../../../Components/Videos/PlaylistVideos";
import { Dialog } from "primereact/dialog";

const Factors = (props) => {
  const [customerId, setCustomerId] = useState(null);
  const [customerControlFields, setCustomerControlFields] = useState(null);
  const [customerOptions, setCustomerOptions] = useState({});
  const [promptTabs, setPromptTabs] = useState([]);
  const [promptTab1, setPromptTab1] = useState([]);
  const [promptTab2, setPromptTab2] = useState([]);
  const [internalData, setInternalData] = useState([]);
  const [externalData, setExternalData] = useState([]);
  const toastRef = useRef();
  const [allData, setAllData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [maxScore, setMaxScore] = useState(0);
  const [showVideo, setShowVideo] = useState(false);

  const navigate = useNavigate()
  const {
    handleSubmit,
    formState: { errors },
    control,
  } = useForm({
    defaultValues: internalData.reduce((acc, field) => {
      acc[field._id] = field.weightage || ""; // Initialize default values
      return acc;
    }, {}),
  });
  const [newModule, setNewModule] = useState({});

  const optionNames = [
    "WorkType",
    "FormOfContractV1",
    "ProcurementRoute",
    "SectorV1",
    "ClientMeetings",
    "ConnectionsToProfessionalTeam",
    "SourceOfOpportunity",
    "FormOfContractV2",
    "TenderPeriod",
    "ProjectValue",
    "ProjectDuration",
    "NoOfCompetitorsV2",
    "onerousTermsLADs",
    "PaymentTermsDays",
    "Winnability",
    "SelectionweightingFactors",
    "Funding",
    "ClientHistory",
    "ClientTypeV1",
    "ResourcingTheBid",
    "ResourcingTheProject",
    "MarginExpected",
    "PlanningStatus",
  ];

  useEffect(() => {
    if (promptTab1 && promptTab1) {
      let obj1 = promptTab1;
      let obj2 = promptTab2;
      let combined = { obj1, obj2 };
      setNewModule(combined)
    }

  }, [promptTab1, promptTab2])

  useEffect(() => {
    // Fetching end user data from local storage
    const enduserStr = localStorage.getItem("enduser");

    // Checking if end user data exists in local storage
    if (enduserStr) {
      // Parsing end user data
      const enduser = JSON.parse(enduserStr);

      // Extracting customer information from end user data
      const customer = enduser.customer;

      // Setting customer ID state
      setCustomerId(customer);
    } else {
      // Logging if no end user data found in local storage
      navigate("/login")
      localStorage.clear()
    }
  }, []);

  useEffect(() => {
    getCustomer();
    getCustomerControl();
  }, [customerId]);

  // Function to get customer reference data.
  const getCustomer = async () => {
    try {
      if (customerId === null) {
        return;
      }
      setLoading(true);
      if (customerId) {
        const customer = await get(customerId);
        if (customer) {
          setAllData(customer?.data);
          const internalData = customer?.data?.reference_data?.filter(
            (item) => item.factor === "Internal"
          );
          setInternalData(internalData);

          const externalData = customer?.data?.reference_data?.filter(
            (item) => item.factor === "External"
          );
          setExternalData(externalData);

          // WinWorkStage
          const refDataWinWorkStage = customer?.data?.reference_data?.find(
            (item) => item.option_names === "WinWorkStage"
          );
          if (refDataWinWorkStage && refDataWinWorkStage.option_choice) {
            const activeOptions = refDataWinWorkStage.option_choice.filter(
              (option) => option.status === "active"
            );
            setCustomerOptions((prevState) => ({
              ...prevState,
              WinWorkStageOtps: activeOptions,
            }));
          }

          // SectorV1
          const refDataSectorV1 = customer?.data?.reference_data?.find(
            (item) => item.option_names === "SectorV1"
          );
          if (refDataSectorV1 && refDataSectorV1.option_choice) {
            const activeOptions = refDataSectorV1.option_choice.filter(
              (option) => option.status === "active"
            );
            activeOptions.unshift({ label: "All", status: "active", score: 0 });
            setCustomerOptions((prevState) => ({
              ...prevState,
              SectorV1Opts: activeOptions,
            }));
          }

          // BusinessUnit
          const refDataBusinessUnit = customer?.data?.reference_data?.find(
            (item) => item.option_names === "BusinessUnit"
          );
          if (refDataBusinessUnit && refDataBusinessUnit.option_choice) {
            const activeOptions = refDataBusinessUnit.option_choice.filter(
              (option) => option.status === "active"
            );
            setCustomerOptions((prevState) => ({
              ...prevState,
              BusinessUnitOpts: activeOptions,
            }));
          }

          // Services
          const referenceDataServices = customer?.data?.reference_data?.find(
            (item) => item.option_names === "Services"
          );
          if (referenceDataServices && referenceDataServices.option_choice) {
            const activeOptions = referenceDataServices.option_choice.filter(
              (option) => option.status === "active"
            );
            setCustomerOptions((prevState) => ({
              ...prevState,
              ServicesOpts: activeOptions,
            }));
          }

          // Region
          const referenceDataRegion = customer?.data?.reference_data?.find(
            (item) => item.option_names === "Region"
          );
          if (referenceDataRegion && referenceDataRegion.option_choice) {
            const activeOptions = referenceDataRegion.option_choice.filter(
              (option) => option.status === "active"
            );
            setCustomerOptions((prevState) => ({
              ...prevState,
              RegionOpts: activeOptions,
            }));
          }

          const referenceDataRoUser = customer?.data?.reference_data?.find(
            (item) => item.option_names === "BDLongShotRole"
          );
          if (referenceDataRoUser && referenceDataRegion.option_choice) {
            let optionList = [];
            for (var i = 0; i < referenceDataRoUser.option_choice.length; i++) {
              optionList.push({
                id: i + 1,
                label: referenceDataRoUser.option_choice[i].label,
              });
            }
            setCustomerOptions((prevState) => ({
              ...prevState,
              RoUsersOpts: optionList,
            }));
          }
          setLoading(false);
        }
      }
    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: 'An error occurred. Please try again or Contact Admin.'
      });
    } finally {
      setLoading(false)
    }
  };

  // Function to fetch and set customer control fields data
  const getCustomerControl = async () => {
    try {
      if (customerId === null) {
        return;
      }
      // Check if customerId is available
      if (customerId !== null) {
        // Fetch customer control field data
        const customerData = await getCustomerControlField(customerId);
        // Extract and set customer control fields
        const controlFields = customerData?.data?.cust[0].modules[0];
        const promptTabs = controlFields.tabs.filter(
          (tab) => tab.tab_name === "Factors"
        );
        setPromptTabs(promptTabs)
        setPromptTab1(promptTabs[0].tables[0].display_name);
        setPromptTab2(promptTabs[0].tables[1].display_name);
        setCustomerControlFields(controlFields);
      }
    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: 'An error occurred. Please try again or Contact Admin.'
      });
    }
  };

  const onSubmit = async (promptData) => {
    setLoading(true);
    const transformedData = Object.entries(promptData).map(
      ([id, weightage]) => {
        return {
          _id: id,
          weightage: Number(weightage),
        };
      }
    );

    const newInternalData = internalData?.map((item) => {
      // Find the matching transformedData entry
      const match = transformedData?.find((data) => data._id === item._id);

      // Return updated item with new weightage if a match is found, otherwise return the original item
      return match ? { ...item, weightage: match.weightage } : item;
    });
    const newExternalData = externalData?.map((item) => {
      // Find the matching transformedData entry
      const match = transformedData?.find((data) => data._id === item._id);

      // Return updated item with new weightage if a match is found, otherwise return the original item
      return match ? { ...item, weightage: match.weightage } : item;
    });

    var originalData = allData;
    const notInternalorExternal = originalData?.reference_data?.filter(
      (item) => item?.factor !== "Internal" && item?.factor !== "External"
    );

    // Concatenate newInternalData and newExternalData with notInternalorExternal
    const combinedData = [
      ...newInternalData,
      ...newExternalData,
      ...notInternalorExternal,
    ];

    // Optionally, remove duplicates if necessary, e.g., by using a Set or unique identifier
    // Assuming `_id` is unique for each item and we want to remove duplicates based on `_id`
    const uniqueCombinedData = Array.from(
      new Map(combinedData.map((item) => [item._id, item])).values()
    );

    // Calculate maxScore based on newFilter
    const calculatedMaxScore = uniqueCombinedData.reduce((acc, item) => {
      if (optionNames?.includes(item.option_names) && item.weightage) {
        return acc + (item.weightage * 4);

      }
      return acc;
    }, 0);

    // // Set the calculated maxScore
    setMaxScore(calculatedMaxScore);
    originalData.reference_data = uniqueCombinedData;
    originalData.total_value = calculatedMaxScore
    // Log form data and maxScore

    try {
      if (customerId === null) {
        toastRef.current.showToast({
          type: 'error',
          message: 'Missing customer ID'
        });
        return;
      }
      if (customerId) {
        const response = await updateRef(customerId, originalData);
        if (response && response?.status === 200 && response?.data?.message === "Customer saved") {
          toastRef.current.showToast({
            type: "success",
            message: `${customerControlFields &&
              customerControlFields.tabs[7]?.display_name
              } Info Updated Successfully`,
          });
        }
        else {
          toastRef.current.showToast({
            type: "error",
            message: `${customerControlFields &&
              customerControlFields.tabs[7]?.display_name
              } Not saved `,
          });
        }
      }

    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: 'An error occurred. Please try again or Contact Admin.'
      });
    } finally {
      setLoading(false)
    }
  };

  const handleButtonClick = () => {
    setShowVideo(true);
};

const closeVideo = () => {
    setShowVideo(false);
};


  return (
    <div>
      <ToastElement ref={toastRef} />
      <Loader loading={loading} />
      <div className="header-design mt-20">
        <p className="fs-16 fw-600 mar-b-3">{promptTabs[0]?.display_name}</p>
          <ButtonElement className="upload-button" type="button" icon="pi pi-video" onClick={handleButtonClick}></ButtonElement>
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        {
          Object.entries(newModule)?.map(([key, value]) => (
            <div key={key} className='mt-10'>
              <Accordion activeIndex={0}>
                {
                  <AccordionTab header={value} disabled>
                    {
                      key == 'obj1' &&
                      <div className="new-field d-flex">
                        <div className="col-md-6 pl-0">
                          {internalData
                            ?.slice(0, Math.ceil(internalData.length / 2))
                            .map((field, index) => (
                              <div
                                key={index}
                                className="form-group row align-items-center mb-0 mt-0"
                              >
                                <div className="col-md-6 pl-0 pr-2">
                                  <label className="form-label text-left">
                                    {field?.display_name} :
                                  </label>
                                </div>
                                <div className="col pr-0" >
                                  <Controller
                                    // name={field._id} // Use unique name for each input
                                    name={field._id}
                                    control={control}
                                    defaultValue={field.weightage > 0 ? field.weightage || "" : 0} // Correctly set default value
                                    rules={{
                                      pattern: {
                                        value: /^[0-9]*$/,
                                        message: "Please enter a valid number",
                                      },
                                    }}
                                    render={({ field }) => (
                                      <InputTextElementElement
                                        id={field._id}
                                        name={field?.display_name}
                                        className="w-full"
                                        {...field}
                                      />
                                    )}
                                  />
                                  {errors[field._id] && (
                                    <small className="text-red-500 ml-1 color_red_new">
                                      {errors[field._id]?.message}
                                    </small>
                                  )}
                                </div>
                              </div>
                            ))}
                        </div>

                        <div className="col-md-6 pl-0">
                          {internalData
                            ?.slice(Math.ceil(internalData.length / 2))
                            .map((field, index) => (
                              <div
                                key={index}
                                className="form-group row align-items-center mb-0 mt-0"
                              >
                                <div className="col-md-6 pl-0 pr-2">
                                  <label className="form-label text-left">
                                    {field?.display_name} :
                                  </label>
                                </div>
                                <div className="col pr-0" >
                                  <Controller
                                    name={field._id} // Use unique name for each input
                                    control={control}
                                    defaultValue={field.weightage > 0 ? field.weightage || "" : 0} // Correctly set default value
                                    rules={{
                                      pattern: {
                                        value: /^[0-9]*$/,
                                        message: "Please enter a valid number",
                                      },
                                    }}
                                    render={({ field }) => (
                                      <InputTextElementElement
                                        placeholder="Text"
                                        name={field._id}
                                        type="number"
                                        className="w-full"
                                        {...field}
                                      />
                                    )}
                                  />
                                </div>
                              </div>
                            ))}
                        </div>
                      </div>
                    }
                    {
                      key == 'obj2' &&
                      <div className="new-field d-flex">
                        <div className="col-md-6 pl-0">
                          {externalData
                            ?.slice(0, Math.ceil(externalData.length / 2))
                            .map((field, index) => (
                              <div
                                key={index}
                                className="form-group row align-items-center mb-0 mt-0"
                              >
                                <div className="col-md-6 pl-0 pr-2">
                                  <label className="form-label text-left">
                                    {field?.display_name} :
                                  </label>
                                </div>
                                <div className="col pr-0" style={{ width: "200px" }}>
                                  <Controller
                                    // name={field._id} // Use unique name for each input
                                    name={field._id}
                                    control={control}
                                    defaultValue={field.weightage > 0 ? field.weightage || "" : 0} // Correctly set default value
                                    rules={{
                                      pattern: {
                                        value: /^[0-9]*$/,
                                        message: "Please enter a valid number",
                                      },
                                    }}
                                    render={({ field }) => (
                                      <InputTextElementElement
                                        id={field._id}
                                        name={field?.display_name}
                                        className="w-full"
                                        {...field}
                                      />
                                    )}
                                  />
                                  {errors[field._id] && (
                                    <small className="text-red-500 ml-1 color_red_new">
                                      {errors[field._id]?.message}
                                    </small>
                                  )}
                                </div>
                              </div>
                            ))}
                        </div>

                        <div className="col-md-6 pl-0">
                          {externalData
                            ?.slice(Math.ceil(externalData.length / 2))
                            .map((field, index) => (
                              <div
                                key={index}
                                className="form-group row align-items-center mb-0 mt-0"
                              >
                                <div className="col-md-6 pl-0 pr-2">
                                  <label className="form-label text-left">
                                    {field?.display_name} :
                                  </label>
                                </div>
                                <div className="col pr-0">
                                  <Controller
                                    name={field._id} // Use unique name for each input
                                    control={control}
                                    defaultValue={field.weightage > 0 ? field.weightage || "" : 0} // Correctly set default value
                                    rules={{
                                      pattern: {
                                        value: /^[0-9]*$/,
                                        message: "Please enter a valid number",
                                      },
                                    }}
                                    render={({ field }) => (
                                      <InputTextElementElement
                                        placeholder="Text"
                                        name={field._id}
                                        type="number"
                                        className="w-full"
                                        {...field}
                                      />
                                    )}
                                  />
                                </div>
                              </div>
                            ))}
                        </div>
                      </div>
                    }
                  </AccordionTab>
                }
              </Accordion>
            </div>
          ))
        }
        <div className="cancel-footer mt-20">
          <div className="d-flex align-center justify-end pb-0">
            <ButtonElement className="save-button" type="submit" label="Save" />
          </div>
        </div>
        <Dialog id="videoModal" visible={showVideo}
            breakpoints={{
                '1200px': '80vw',    // Larger modal on bigger screens
                '1024px': '85vw',    // Slightly smaller for medium screens
                '769': '90vw',     // Responsive on tablets
                '641px': '95vw',     // Almost full-width on mobile
            }}
            modal className="table-dialog width-32" draggable={false} width="800px" height="500px" onHide={closeVideo}
        >
            <div className="video-overlay">
                <div className="video-container">
                    <PlaylistVideos playlistId={process.env.REACT_APP_CONTROL_PANEL_PLAYLIST_ID} apiKey={process.env.REACT_APP_GOOGLE_API_KEY} module="control_panel_factors" />
                </div>
            </div>
        </Dialog>
      </form>
    </div>
  );
};

export default Factors;
